import { useSelector, useDispatch } from "react-redux";
import { useState,useEffect } from "react";
import _ from "lodash";
import SensorDetail from "./SensorDetail";
import AttachSensor from "./AttachSensor";
import { Row,  Col } from "react-bootstrap";
import { Icon } from "@iconify/react";
import ToolTip from "../Common/Tooltip";
import { SET_ONGOING_EDIT_GLOBALLY } from "../../../store/actions";
import SensorRevert from "./SensorRevertPopup";
import { sensorJson } from "../../../Common/sensorData";

const SensorAndBearingList = () => {

    const selectedComponent = useSelector(state => state.equipment.selectedComponent);
    const isEditOngoing = useSelector(state => state.equipment.isEditOngoing);
    const isLockedProfile = useSelector(state => state.equipment.isLockedProfile);
    const dispatch = useDispatch();

   
    const [utils, setUtils] = useState({
        sensors: [],
        isSensorAttachActive: false,
        blockedInstallLocations: [],
        showSensorRevertPopup: false,
        availableLocations: []
    });

    useEffect(() => {
        if(!_.isEmpty(selectedComponent?.id) && !_.isEmpty(selectedComponent.sensors)) {
            let locations = [], sensors = [];
            selectedComponent.sensors.forEach((sensor) => {
                sensors.push(sensor);
                if(!_.isEmpty(sensor.installLocation)) {
                    locations.push(sensor.installLocation);
                }
            });
            setUtils({
                ...utils, availableLocations: sensorJson[selectedComponent.class].install_locations.values,
                sensors: sensors, blockedInstallLocations: locations, isSensorAttachActive: false
            });
        }
        else {
            setUtils({ sensors: [] });
        }
    }, [selectedComponent]);

    const showSensorAttachFields = (action) => {
        dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: action });
        setUtils({ ...utils, isSensorAttachActive: action });
    }

    const headerClass = () => `w-100 p-0 m-0 ${!_.isEmpty(utils.sensors) && !utils.isSensorAttachActive ? "populated" : "empty"}-sensor-list-header`

    return (
        <>
            <Row className={headerClass()} style={{"height": "25px"}}>
                <Col sm={10} xs={10} lg={10} md={10} xl={10} className="p-0">
                    <center className="font-weight-bold">Sensor list</center>
                </Col>
                {
                    !utils.isSensorAttachActive && !isLockedProfile &&
                    <>
                        <Col sm={1} xs={1} lg={1} md={1} xl={1} className="p-0">
                            <ToolTip toolTipKey="attach-sensor" toolTipValue="Attach Sensor"
                                overlayComponent={
                                    <Icon
                                        className={`cursor-pointer ${isEditOngoing && 'disable-click text-color-grey'}`}
                                        onClick={() => showSensorAttachFields(true)}
                                        width={18} icon={"feather-plus"}
                                    />
                                } 
                            />
                        </Col>
                        <Col sm={1} xs={1} lg={1} md={1} xl={1} className="p-0">
                            <ToolTip toolTipKey="revert-sensor" toolTipValue="Revert Sensor"
                                overlayComponent={
                                    <Icon
                                        className={`cursor-pointer ${isEditOngoing && 'disable-click text-color-grey'}`}
                                        onClick={() => setUtils({ ...utils, showSensorRevertPopup: true })}
                                        width={16} icon={"feather-rotate-ccw"}
                                    />
                                }
                            />
                        </Col>
                    </>
                }
            </Row>

            {
                utils.isSensorAttachActive ?
                    <AttachSensor
                        blockedInstallLocations={utils.blockedInstallLocations}
                        hideSensorAttachFields={() => showSensorAttachFields(false)}
                        componentId={selectedComponent?.id}
                        sensors={utils.sensors}
                    />
                        :
                    !_.isEmpty(utils.sensors) ?
                        <>
                            {
                                utils.sensors.map((sensor) => 
                                    {
                                        return (
                                            <SensorDetail
                                                id={sensor.id}
                                                metadata={{ ...sensor.metadata, location: sensor.installLocation }}
                                                bearingInformation ={{bearingInformation : sensor.bearingInformation}}
                                                availableLocations={utils.availableLocations}
                                            />
                                        )
                                    }
                                )
                            }
                        </>
                            :
                        <center className="px-3 mt-3">
                            <b>NO SENSORS FOUND</b>
                        </center>
            }
            {
                utils.showSensorRevertPopup &&
                <SensorRevert
                    hidePopup={() => setUtils({ ...utils, showSensorRevertPopup: false })}
                    componentId={selectedComponent?.id}
                />
            }
        </>
    );
}

export default SensorAndBearingList;